// extracted by mini-css-extract-plugin
module.exports = {"header":"Iel2Y","body":"_230uY","li":"rv5MO","ul":"_3kxJF","title":"_3vHHv","open":"_18g5r","flasher":"_1HR95"};